/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Upload_HelperInputs */

const en_dialog_upload_helper = /** @type {(inputs: Dialog_Upload_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion usually finishes in a couple of minutes—you can keep working while it processes.`)
};

const es_dialog_upload_helper = /** @type {(inputs: Dialog_Upload_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversión generalmente termina en un par de minutos—puedes seguir trabajando mientras se procesa.`)
};

/**
* | output |
* | --- |
* | "Conversion usually finishes in a couple of minutes—you can keep working while it processes." |
*
* @param {Dialog_Upload_HelperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_upload_helper = /** @type {((inputs?: Dialog_Upload_HelperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Upload_HelperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_upload_helper(inputs)
	return en_dialog_upload_helper(inputs)
});